import type { ProductContentFragment } from '@/lib/types/datocms/graphql/generated'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'

import { StructuredText } from 'react-datocms'

export default function ProductContentSection({
	productContent,
}: Readonly<ProductContentFragment>) {
	if (productContent && !isStructuredTextEmpty(productContent)) {
		return (
			<section className="product-content-section common-x-padding max-w-screen-2xl mx-auto py-10 @container">
				<div className="rich-text">
					<StructuredText data={productContent} />
				</div>
			</section>
		)
	}
}
